<section class="p-3">
  <h2 class="title mb-4">Cuenta y seguridad</h2>

  <article class="row mx-3">
    <p-card class="col-12 col-xl-4 mb-3" header="Acceso">
      <p-floatlabel class="my-3 d-block" variant="in">
        <p-iconfield>
          <p-inputicon class="pi pi-user" />

          <input pInputText type="text" id="username" [value]="username" readonly class="w-100" />

          <p-inputicon> </p-inputicon>
        </p-iconfield>
        <label for="password">Usuario</label>
      </p-floatlabel>

      @if (sendRequestsEnabled()) {
        <p>
          Si necesitas modificar estos datos, envíanos una consulta a través del formulario
          <a [routerLink]="['/', 'enviar-consulta']">Enviar consulta</a>, indicando los cambios que
          deseas realizar.
        </p>
      }

      <p-footer>
        <div
          class="d-flex align-items-center p-3 rounded-4 bg-light border border-light-subtle w-100"
        >
          <div
            class="d-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10"
            style="width: 40px; height: 40px; min-width: 40px"
          >
            <i class="pi pi-history text-primary" style="font-size: 1.2rem"></i>
          </div>

          <div class="ms-3">
            <div class="fw-bold text-dark" style="font-size: 0.875rem; line-height: 1.2">
              Última sesión
            </div>
            <div class="text-secondary mt-1" style="font-size: 0.815rem">
              {{ lastAccessDate ? (lastAccessDate | date: 'dd/MM/yyyy HH:mm') : 'Cargando...' }}
            </div>
          </div>
        </div>
      </p-footer>
    </p-card>
    <!-- <div class="col-xl-7"></div> -->

    <p-card class="col-12 col-xl-4 ms-xl-3 mb-3" header="Cambiar contraseña">
      <form [formGroup]="passwordForm">
        <p-floatlabel class="my-3 d-block password-field" variant="in">
          <p-iconfield>
            <!-- <p-inputicon class="pi pi-lock" /> -->

            <input
              pInputText
              [type]="showCPassword ? 'text' : 'password'"
              id="password"
              class="w-100"
              formControlName="currentPassword"
              autocomplete="current-password"
            />

            <p-inputicon>
              <p-button
                [icon]="showCPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"
                [text]="true"
                [rounded]="true"
                severity="secondary"
                (onClick)="showCPassword = !showCPassword"
                type="button"
              />
            </p-inputicon>
          </p-iconfield>
          <label for="password">Contraseña actual</label>
        </p-floatlabel>

        <p-floatlabel class="my-3 d-block password-field" variant="in">
          <p-iconfield>
            <!-- <p-inputicon class="pi pi-lock" /> -->

            <input
              pInputText
              [type]="showPassword ? 'text' : 'password'"
              id="new-password"
              class="w-100"
              formControlName="newPassword"
              autocomplete="new-password"
            />

            <p-inputicon>
              <p-button
                [icon]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"
                [text]="true"
                [rounded]="true"
                severity="secondary"
                (onClick)="showPassword = !showPassword"
                type="button"
              />
            </p-inputicon>
          </p-iconfield>
          <label for="new-password">Contraseña nueva</label>
        </p-floatlabel>

        <p-floatlabel class="my-3" variant="in">
          <p-iconfield>
            <input
              pInputText
              type="password"
              id="repeat-password"
              class="w-100"
              formControlName="repeatPassword"
              autocomplete="new-password"
            />
          </p-iconfield>
          <label for="repeat-password">Repetir contraseña nueva</label>
        </p-floatlabel>

        <div class="d-flex w-100">
          <p-button
            [disabled]="passwordForm.invalid"
            (onClick)="changePassword()"
            label="Cambiar contraseña"
            class="ms-auto"
          ></p-button>
        </div>
      </form>
    </p-card>

    <p-card header="Requisitos" class="col-12 col-xl-3 ms-xl-3 mb-3">
      <div class="password-hints mb-3">
        <small [class.text-success]="passErrors.hasMinLength" class="d-block my-2">
          <i class="pi" [ngClass]="passErrors.hasMinLength ? 'pi-check' : 'pi-times'"></i>
          Mínimo 8 caracteres
        </small>

        <small [class.text-success]="passErrors.hasMaxLength" class="d-block mb-2">
          <i class="pi" [ngClass]="passErrors.hasMaxLength ? 'pi-check' : 'pi-times'"></i>
          Máximo 10 caracteres
        </small>

        <small [class.text-success]="passErrors.hasUpper" class="d-block mb-2">
          <i class="pi" [ngClass]="passErrors.hasUpper ? 'pi-check' : 'pi-times'"></i>
          Una mayúscula
        </small>

        <small [class.text-success]="passErrors.hasLower" class="d-block mb-2">
          <i class="pi" [ngClass]="passErrors.hasLower ? 'pi-check' : 'pi-times'"></i>
          Una minúscula
        </small>

        <small [class.text-success]="passErrors.hasNumber" class="d-block mb-2">
          <i class="pi" [ngClass]="passErrors.hasNumber ? 'pi-check' : 'pi-times'"></i>
          Un número
        </small>

        <small [class.text-success]="passErrors.hasSymbol" class="d-block mb-2">
          <i class="pi" [ngClass]="passErrors.hasSymbol ? 'pi-check' : 'pi-times'"></i>
          Un símbolo
        </small>

        <small [class.text-success]="passwordsMatch" class="d-block mb-2">
          <i class="pi" [ngClass]="passwordsMatch ? 'pi-check' : 'pi-times'"></i>
          Las contraseñas coinciden
        </small>
      </div>
    </p-card>
  </article>
</section>

